var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-date"},[_c('p',{staticClass:"is-size-5 has-text-weight-bold",style:(_vm.textColor)},[_c('location-icon',{staticClass:"location-icon mr-1",style:(_vm.textColor)}),_vm._v(" "+_vm._s(_vm.location)+" ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }